import { useMemo, useState } from 'react';

// Types.
import HostTarget from '../../../types/host/HostTarget';
import ChartPlotLine from '../../../types/ChartPlotLine';

// Constants.
import { CHART_DATA_TYPE, VIEW_MODE } from '../../Constants';

import ConditionalRender from '../../../helpers/ConditionalRender';

import TimeSeriesChart from '../../chart/echarts/TimeSeriesChart';
import { EChartTimeSeries } from '../../chart/echarts/types';
import HostChartCard from './HostChartCard';
import { toMetricSeries, useHostStatistic } from './useHostStatistic';

const CPU_TICK_METRICS = [
    'non-nice user cpu ticks',
    'nice user cpu ticks',
    'system cpu ticks',
    'IO-wait cpu ticks',
    'IRQ cpu ticks',
    'softirq cpu ticks',
    'stolen cpu ticks',
];

function ProcessorChart(props: { host: HostTarget, plotLines?: ChartPlotLine[] }) {
    const [mode, setMode] = useState<number>(VIEW_MODE.BASIC);
    const { loading, rows, timeSeries, peak: timePeak } = useHostStatistic(props.host, 'cpuutilisation');
    const basicSeries = useMemo<EChartTimeSeries[]>(() => [{
        name: 'Average CPU',
        chartType: 'line',
        data: timeSeries,
    }], [timeSeries]);

    const detailSeries = useMemo<EChartTimeSeries[]>(() => toMetricSeries(rows, CPU_TICK_METRICS), [rows]);

    return (
        <HostChartCard
            cardTitle="Average CPU over time"
            chartTitle="Average CPU"
            collapseId="collapseProcessorCharts"
            peakLabel="Peak Average CPU"
            peakValue={timePeak}
            peakSuffix="%"
            mode={mode}
            onToggleMode={() => setMode(mode === VIEW_MODE.BASIC ? VIEW_MODE.DETAIL : VIEW_MODE.BASIC)}
            loading={loading}
        >
            <ConditionalRender if={mode === VIEW_MODE.BASIC}>
                <TimeSeriesChart series={basicSeries} tooltipType={CHART_DATA_TYPE.PERCENTAGE}
                                 plotLines={props.plotLines}/>
            </ConditionalRender>

            <ConditionalRender if={mode === VIEW_MODE.DETAIL}>
                <TimeSeriesChart series={detailSeries} tooltipType={CHART_DATA_TYPE.GENERIC}
                                 plotLines={props.plotLines} legend={true}/>
            </ConditionalRender>
        </HostChartCard>
    );
}

export default ProcessorChart;
